export const POSTHOG_API_HOST = "https://eu.i.posthog.com";
